export { delegateUrl } from "./vercel.js";
import { parse as vercelParse, transform as vercelTransform, } from "./vercel.js";
export const parse = (url) => ({ ...vercelParse(url), cdn: "nextjs" });
export const transform = (params) => vercelTransform({ ...params, cdn: "nextjs" });
